import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { Box, BoxDto } from '@app/store/placed-boxes/models';
import { CartonsStatus } from '../models';
import { mapDto } from '@shared/operators';
import { hasMore, PaginatedApiResponse } from '@shared/models/api-response';

const PAGE_SIZE = 20;

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    loadCartons(status: CartonsStatus, page: number): Observable<{ boxes: Box[]; hasMore: boolean }> {
        return this.httpClient
            .get<PaginatedApiResponse<BoxDto[]>>('cartons', { params: { status, sort: 'createdAt', order: 'desc', page, limit: PAGE_SIZE } })
            .pipe(
                mapDto((response) => ({
                    boxes: response.data.map((dto) => new Box(dto)),
                    hasMore: hasMore(response),
                })),
            );
    }
}
